import axios from "axios";
import React from "react";

// export const baseURL = "http://localhost:8080/api";
// export const baseURL = "http://live.hioctanelabs.com:8080/api";
export const baseURL = "https://live.hioctanelabs.com/api";
const passCode = "56672d5c35749cf03560d4a36012d8a9";

export const createSession = () => {
    let data = passCode;
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': null
    };    
    return new Promise((resolve, reject) => {
        axios.post(baseURL + "/session/create", passCode).then((resp) => {
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const loginUser = (sessionId, emailAddress, password) => {
    // console.log("Now invoking loginSession with",sessionId);
    // console.log(emailAddress, password);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const userInfo = {
        "emailAddress":emailAddress,
        "password":password
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/user/login",
            data: userInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("login response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const registerUser = (sessionId, emailAddress, password, firstName, lastName, deviceSerial) => {
    console.log("Now invoking registerSession with",sessionId);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const userInfo = {
        "firstName":firstName,
        "lastName":lastName,
        "deviceSerial":deviceSerial,
        "emailAddress":emailAddress,
        "password":password
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/user/register",
            data: userInfo,
            headers: _headers,
          }).then(response => {
              console.log("response",response);
              resolve(response.data);
          }).catch(error => {
              console.log('Error invoking register API', error);
              reject(error);
          })
    })
}

export const getMyProfile = (sessionId, userId) => {
    console.log("Now invoking getMyProfile with",sessionId);
    console.log("With User Id", userId);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const userInfo = {
        "id":userId
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/user/profile",
            data: userInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("getMyProfile response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const dashboardData = (sessionId, mode,deviceSerial) => {
    // console.log("Now invoking dashboardData with",sessionId);
    // console.log("and deviceSerial",deviceSerial);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const searchInfo = {
        'graphModeStr':mode,
        'deviceSerial':deviceSerial
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/iot/getdashboard",
            data: searchInfo,
            headers: _headers,
        }).then((resp) => {
            // console.log("dashboardData response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const emailConfirm = (sessionId, regCode) => {
    console.log("Now invoking emailConfirm with",sessionId);
    console.log("regCode", regCode);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const userInfo = {
        "regCode":regCode
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/user/emailVerify",
            data: userInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("emailVerify response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log("error Only",error.response.data);
            reject(error);
        })
    })
}

export const resetDevice = (sessionId, deviceSerial, isTrip) => {
    console.log("Now invoking resetDevice with",sessionId);
    console.log("deviceSerial", deviceSerial);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const tripStr = isTrip?"Yes":"No";
    const userInfo = {
        "deviceSerial":deviceSerial,
        "params":[{'key':'isTrip','value':tripStr}]
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/iot/reset",
            data: userInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("resetDevice response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const getAllDeviceSerials = (sessionId) => {
    console.log("Now invoking getAllDeviceSerials with ",sessionId);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const userInfo = {
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/getAll/deviceSerials",
            data: userInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("resetDevice response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const getAlertsData = (sessionId, deviceSerial, alertType, offset, maxRows) => {
    console.log("Now invoking getAlertsData with ",sessionId);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const searchInfo = {
        'alertTypeStr': alertType,
        'deviceSerial': deviceSerial,
        'offset':offset,
        'maxRows':maxRows
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/iot/getalertsdata",
            data: searchInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("getAlertsData response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const updateAlertsData = (sessionId, deviceSerial, alertType, opStr, idStr) => {
    console.log("Now invoking getAlertsData with ",sessionId);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const searchInfo = {
        'typeStr': alertType,
        'deviceSerial': deviceSerial,
        'operationStr': opStr,
        'listIds':idStr
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/iot/updatealertsdata",
            data: searchInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("updatealertsdata response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const updateAddlSerials = (sessionId, userId, addlSerials) => {
    console.log("Now invoking updateAddlSerials with ",sessionId);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const userInfo = {
        'id': userId,
        'addlDeviceSerials':addlSerials
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/user/saveaddlserials",
            data: userInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("updateAddlSerials response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const fogotPassword = (sessionId, email) => {
    console.log("Now invoking fogotPassword with ",sessionId);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const userInfo = {
        'emailAddress': email
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/user/forgotpassword",
            data: userInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("fogotPassword response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}

export const resetPassword = (sessionId, email, resetCode, newPassword) => {
    console.log("Now invoking resetPassword with ",sessionId);
    const _headers = {
        "Content-Type": "application/json",
        'Accept':"*/*",
        'sessionId': sessionId
    };    
    const userInfo = {
        'emailAddress': email,
        'resetPasscode': resetCode,
        'password': newPassword
    };
    return new Promise((resolve, reject) => {
        axios({
            method: "post",
            url: baseURL + "/user/resetpassword",
            data: userInfo,
            headers: _headers,
        }).then((resp) => {
            console.log("resetPassword response",resp);
            resolve(resp.data);
        }).catch(error => {
            console.log(error);
            reject(error);
        })
    })
}
